import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ShowcaseSection } from './components/ShowcaseSection';
import { TechnicalSection } from './components/TechnicalSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';

function App() {
  useEffect(() => {
    // Set page title
    document.title = 'FinanceAI - Controle suas finanças com inteligência artificial';
    
    // Add meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Assuma o controle da sua vida financeira com inteligência artificial. Organize, planeje e construa estabilidade financeira por apenas R$ 29,99.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <HeroSection />
      <ProblemSection />
      <ShowcaseSection />
      <TechnicalSection />
      <BenefitsSection />
      <PricingSection />
      <Footer />
    </div>
  );
}

export default App;
